export default "__VITE_ASSET__Be$XjqJ8__"